import { GenIcon } from '../helpers/IconBase.es.js';

const DoubleArrowFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.60188 10C9.1723 10 8.94272 9.49404 9.2256 9.17075L11.2474 6.86009C11.6458 6.40476 12.3542 6.40476 12.7526 6.86009L14.7744 9.17075C15.0573 9.49404 14.8277 10 14.3981 10H9.60188ZM12.7526 17.1399C12.3542 17.5952 11.6458 17.5952 11.2474 17.1399L9.2256 14.8293C8.94272 14.506 9.1723 14 9.60188 14H14.3981C14.8277 14 15.0573 14.506 14.7744 14.8293L12.7526 17.1399Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { DoubleArrowFilled };
